<template>
  <div>
    <SchemaTablePage
      layout-mode="page"
      ref="tablePageRef"
      :search-schema="searchSchema"
      :columns="tableColumns"
      :default-query="defaultQuery"
      :request="request"
      :build-params="buildParams"
      :parse-result="parseResult"
      :table-listeners="tableListeners"
    >
      <template #table-header>
        <el-button size="mini" type="primary" @click="handleCreate">新增</el-button>
        <el-button size="mini" type="primary" @click="handleBatchRemove">批量移除</el-button>
      </template>
      <!-- <template #colUsername="{ row }">
        <MemberAccountCell :row="row" :username="row.username" :uid="row.uid" :vip-level="row.vip_level" />
      </template> -->
      <template #colType="{ row }">
        <el-tag size="mini">
          {{ getTypeName(row.block_type) }}
        </el-tag>
        <!-- <el-button type="text" size="small" @click="handleCopy(row)" v-if="[2, 3].includes(row.block_type)">
          {{ row.block_value }}</el-button
        > -->
        &nbsp;
        <span>{{ row.block_value }}</span>
      </template>

      <template #colMethod="{ row }">
        {{ getMethodName(row.limit_type) }}
      </template>
      <template #colCreatedAt="{ row }">
        {{ row.created_at | formatTimestamp }}
      </template>
      <template #colActions="{ row }">
        <el-popconfirm title="确认移除该条黑名单？" @confirm="handleRemove(row)">
          <template #reference>
            <el-button type="text" size="small">移除</el-button>
          </template>
        </el-popconfirm>
        <el-button type="text" size="small" @click="handleEdit(row)">编辑</el-button>
      </template>
    </SchemaTablePage>

    <CreateBlackDialog
      :visible.sync="dialogVisible"
      :row="editingRow"
      :type-options="typeOptions"
      :method-options="methodOptions"
      @saved="handleSaved"
    />
  </div>
</template>

<script>
import SchemaTablePage from '@/components/SchemaTablePage'
import { loginLogApi } from '@/api/riskControl/loginLog'
import { getCurrentInstance, ref } from 'vue'
import CreateBlackDialog from './components/CreateBlackDialog.vue'
import MemberAccountCell from '@/components/MemberAccountCell.vue'
import { typeOptions, methodOptions } from './const'

export default {
  name: 'ManageList',
  components: {
    SchemaTablePage,
    CreateBlackDialog,
    MemberAccountCell,
  },

  setup() {
    const { proxy } = getCurrentInstance() || {}
    const dialogVisible = ref(false)
    const editingRow = ref(null)
    const selectedRows = ref([])

    const tableListeners = {
      'selection-change': rows => {
        selectedRows.value = Array.isArray(rows) ? rows : []
      },
    }

    const searchSchema = [
      {
        label: '限制类型',
        component: 'select',
        prop: 'block_type',
        options: typeOptions,
        componentProps: { clearable: true },
      },
      {
        label: '限制值',
        component: 'input',
        prop: 'block_value',
        componentProps: { clearable: true, placeholder: '请输入' },
      },
      {
        label: '限制方式',
        component: 'select',
        prop: 'limit_type',
        options: methodOptions,
        componentProps: {
          multiple: true,
        },
      },
      //   {
      //     label: '会员ID',
      //     component: 'input',
      //     prop: 'uid',
      //     componentProps: { clearable: true },
      //   },
      {
        label: '会员账号',
        component: 'input',
        prop: 'username',
      },
      { component: 'actions' },
    ]
    const tableColumns = [
      {
        type: 'selection',
        width: 40,
        align: 'center',
        resizable: false,
      },
      //   {
      //     label: '会员账号',
      //     prop: 'username',
      //     minWidth: 140,
      //     slot: 'colUsername',
      //   },
      {
        label: '限制类型',
        prop: 'block_type',
        slot: 'colType',
        minWidth: 140,
      },
      {
        label: '备注',
        prop: 'reason',
        minWidth: 120,
      },
      {
        label: '限制方式',
        prop: 'limit_type',
        slot: 'colMethod',
        minWidth: 160,
      },
      {
        label: '操作人',
        prop: 'operator',
      },
      {
        label: '添加时间',
        prop: 'created_at',
        minWidth: 120,
        slot: 'colCreatedAt',
      },
      {
        label: '操作',
        prop: 'actions',
        slot: 'colActions',
      },
    ]
    const defaultQuery = {
      block_type: 2,
      block_value: '',
    }
    const request = params => {
      return loginLogApi.getBlacklistList(params)
    }
    const buildParams = ({ query, page, limit }) => {
      const q = query || {}
      const params = { ...q }

      // 拆分：block_type + block_value → 兼容后端字段
      const bt = params.block_type != null && params.block_type !== '' ? Number(params.block_type) : null
      const bv = params.block_value != null ? String(params.block_value).trim() : ''
      delete params.block_value
      if (bt == null || !bv) {
        delete params.block_type
      } else {
        params.block_type = bt
        if (bt === 2) params.ip = bv
        else if (bt === 3) params.device_id = bv
        else if (bt === 4) params.uid = bv
      }

      return {
        ...params,
        page,
        page_size: limit,
      }
    }
    const mapTableData = data => {
      return {
        ...data,
      }
    }
    const mocklist = [
      {
        id: 1,
        username: 'wyl042111',
        uid: 200224,
        // vip_level: 1,
        block_type: 2,
        block_value: '192.168.1.1',
        created_at: 1719168000,
        limit_type: [1, 2, 3],
        operator: 'admin',
        reason: 'ddd',
      },
      {
        id: 2,
        username: 'wyl042111',
        uid: 200224,
        // vip_level: 1,
        block_type: 3,
        block_value: '1234567890',
        created_at: 1719168000,
        limit_type: [1, 2, 3],
        operator: 'admin',
        reason: 'ddd',
      },
      {
        id: 3,
        username: 'wyl042111',
        uid: 200224,
        // vip_level: 1,
        block_type: 4,
        block_value: '200224',
        created_at: 1719168000,
        limit_type: [1, 2, 3],
        operator: 'admin',
        reason: 'ddd',
      },
    ]
    const parseResult = response => {
      if (response && response.code === 0) {
        const list = response.data.list.map(mapTableData)
        return {
          list: list || [],
          total: (response.data && response.data.total) || 0,
        }
      }
      proxy?.$message.error(response?.msg || '获取风控名单失败')
      return { list: [], total: 0 }
    }

    const getTypeName = v => typeOptions.find(o => o.value == v)?.label || v || '--'
    const getMethodName = v => {
      if (!v) return '--'
      const list = typeof v === 'string' ? v.split(',').filter(Boolean) : Array.isArray(v) ? v : [String(v)]
      return list.map(m => methodOptions.find(o => o.value == m)?.label || m).join('、')
    }

    const reloadTable = () => proxy?.$refs?.tablePageRef?.reload?.()

    const handleCreate = () => {
      editingRow.value = null
      dialogVisible.value = true
    }
    const handleBatchRemove = () => {
      if (!selectedRows.value.length) {
        return proxy?.$message?.warning?.('请先勾选要移除的数据')
      }
      const ids = selectedRows.value.map(r => r?.id ?? r?.black_id).filter(v => v != null)
      if (!ids.length) {
        return proxy?.$message?.warning?.('勾选数据缺少ID，无法批量移除')
      }
      proxy
        ?.$confirm?.('确认批量移除？', '提示', { type: 'warning' })
        .then(async () => {
          await loginLogApi.deleteBlacklist({ ids, del_type: 1 })
          proxy?.$message?.success?.('批量移除成功')
          reloadTable()
        })
        .catch(() => {})
    }
    const handleEdit = row => {
      editingRow.value = row
      dialogVisible.value = true
    }
    const handleSaved = () => reloadTable()
    const handleRemove = async row => {
      const id = row?.id ?? row?.black_id
      if (id == null) return proxy?.$message?.warning?.('缺少记录ID，无法删除')
      await loginLogApi.deleteBlacklist({ ids: [id], del_type: 1 })
      proxy?.$message?.success?.('移除成功')
      reloadTable()
    }

    return {
      searchSchema,
      tableColumns,
      defaultQuery,
      request,
      buildParams,
      parseResult,
      typeOptions,
      methodOptions,
      dialogVisible,
      editingRow,
      tableListeners,
      getTypeName,
      getMethodName,
      handleCreate,
      handleBatchRemove,
      handleEdit,
      handleRemove,
      handleSaved,
    }
  },
}
</script>
